import { render, staticRenderFns } from "./JustificatifTable.vue?vue&type=template&id=32b5d442&scoped=true"
import script from "./JustificatifTable.vue?vue&type=script&lang=js"
export * from "./JustificatifTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b5d442",
  null
  
)

export default component.exports